export interface TrailerModel {
  model: string;
  capacity: number;
  boatLength: string;
  overallLength: string;
  bowEyeMin?: string;
  bowEyeMax?: string;
  gvwr: number;
  tongueJack: string;
  axles: number;
  brakes: string;
  tireSize: string;
  overallWidth: string;
  betweenFenders?: string;
  sourceSheet: string;
  price?: number;
  couplerSize?: string;
  suspension?: string;
  rollers?: number;
  minBunkWidth?: string;
  maxBunkWidth?: string;
}

// Raw CSV data converted to TypeScript objects
export const TRAILER_MODELS: TrailerModel[] = [
  // Aluminum Bunk Single Axle
  {
    model: "VAB-1025",
    capacity: 1025,
    boatLength: "12'-14'",
    overallLength: "15'",
    bowEyeMin: "8'2\"",
    bowEyeMax: "12'8\"",
    gvwr: 1230,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "4.80 X 12 LRC 5H",
    overallWidth: "60\"",
    betweenFenders: "42\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-1325",
    capacity: 1325,
    boatLength: "14'-15'",
    overallLength: "18'1\"",
    bowEyeMin: "8'6\"",
    bowEyeMax: "15'6\"",
    gvwr: 1535,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "4.80 X 12 LRC 5H",
    overallWidth: "60\"",
    betweenFenders: "42\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-2025",
    capacity: 2025,
    boatLength: "16'-17'",
    overallLength: "20'3\"",
    bowEyeMin: "13'",
    bowEyeMax: "18'",
    gvwr: 2485,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "ST175/80R 13 LRC 5H",
    overallWidth: "93\"",
    betweenFenders: "76\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-2425",
    capacity: 2425,
    boatLength: "16'-18'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 2985,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST185/80R 13 LRD 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-2625",
    capacity: 2625,
    boatLength: "17'-19'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 3185,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-2825",
    capacity: 2825,
    boatLength: "18'-20'",
    overallLength: "22'1\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 3525,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-3025",
    capacity: 3025,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 3725,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST215/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-3325",
    capacity: 3325,
    boatLength: "20'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 4100,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VAB-3525",
    capacity: 3525,
    boatLength: "20'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 4350,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  // Aluminum Bunk Tandem Axle
  {
    model: "VATB-3625",
    capacity: 3625,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 4585,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-4225",
    capacity: 4225,
    boatLength: "21'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 5165,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-5225",
    capacity: 5225,
    boatLength: "21'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 6165,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-5925",
    capacity: 5925,
    boatLength: "22'-24'",
    overallLength: "25'9\"",
    bowEyeMin: "18'8\"",
    bowEyeMax: "23'",
    gvwr: 6905,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-6425",
    capacity: 6425,
    boatLength: "24'-25'",
    overallLength: "27'7\"",
    bowEyeMin: "19'",
    bowEyeMax: "24'",
    gvwr: 7555,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-7225",
    capacity: 7225,
    boatLength: "25'-26'",
    overallLength: "27'7\"",
    bowEyeMin: "19'",
    bowEyeMax: "24'",
    gvwr: 8525,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-8025",
    capacity: 8025,
    boatLength: "25'-26'",
    overallLength: "30'1\"",
    bowEyeMin: "21'6\"",
    bowEyeMax: "26'",
    gvwr: 9365,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-8725",
    capacity: 8725,
    boatLength: "27'-29'",
    overallLength: "30'9\"",
    bowEyeMin: "21'6\"",
    bowEyeMax: "26'",
    gvwr: 10085,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  // Aluminum Bunk Triple Axle
  {
    model: "VATB-9625",
    capacity: 9625,
    boatLength: "27'-29'",
    overallLength: "31'7\"",
    bowEyeMin: "22'",
    bowEyeMax: "28'",
    gvwr: 11425,
    tongueJack: "Flat Foot",
    axles: 3,
    brakes: "Disc-2",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-12625",
    capacity: 12625,
    boatLength: "29'-33'",
    overallLength: "37'",
    bowEyeMin: "26'",
    bowEyeMax: "31'",
    gvwr: 14485,
    tongueJack: "Flat Foot",
    axles: 3,
    brakes: "Disc-3",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Bunk"
  },
  {
    model: "VATB-15025",
    capacity: 15025,
    boatLength: "32'-36'",
    overallLength: "39'11\"",
    bowEyeMin: "30'",
    bowEyeMax: "35'",
    gvwr: 17505,
    tongueJack: "Flat Foot",
    axles: 3,
    brakes: "Disc-3",
    tireSize: "ST235/80R 16 LRE 8H",
    overallWidth: "102\"",
    betweenFenders: "82\"",
    sourceSheet: "Aluminum Bunk"
  },
  // Aluminum Roller Single Axle
  {
    model: "VAR-2425",
    capacity: 2425,
    boatLength: "16'-18'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 2985,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST185/80R 13 LRD 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Aluminum Roller",
    rollers: 6
  },
  {
    model: "VAR-2625",
    capacity: 2625,
    boatLength: "17'-19'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 3185,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Aluminum Roller",
    rollers: 6
  },
  {
    model: "VAR-2825",
    capacity: 2825,
    boatLength: "18'-20'",
    overallLength: "22'1\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 3525,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VAR-3025",
    capacity: 3025,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 3725,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST215/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VAR-3325",
    capacity: 3325,
    boatLength: "20'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 4100,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VAR-3525",
    capacity: 3525,
    boatLength: "20'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 4350,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  // Aluminum Roller Tandem Axle
  {
    model: "VATR-3625",
    capacity: 3625,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 4585,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VATR-4225",
    capacity: 4225,
    boatLength: "21'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 5165,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VATR-5225",
    capacity: 5225,
    boatLength: "21'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 6165,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 8
  },
  {
    model: "VATR-5925",
    capacity: 5925,
    boatLength: "22'-24'",
    overallLength: "25'9\"",
    bowEyeMin: "18'8\"",
    bowEyeMax: "23'",
    gvwr: 6905,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 10
  },
  {
    model: "VATR-6425",
    capacity: 6425,
    boatLength: "24'-25'",
    overallLength: "27'7\"",
    bowEyeMin: "19'",
    bowEyeMax: "24'",
    gvwr: 7555,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Aluminum Roller",
    rollers: 10
  },
  // Galvanized Bunk Single Axle
  {
    model: "VB-1025",
    capacity: 1025,
    boatLength: "12'-14'",
    overallLength: "15'",
    bowEyeMin: "8'2\"",
    bowEyeMax: "12'8\"",
    gvwr: 1230,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "4.80 X 12 LRC 5H",
    overallWidth: "60\"",
    betweenFenders: "42\"",
    sourceSheet: "Galvanized Bunk"
  },
  {
    model: "VB-2025",
    capacity: 2025,
    boatLength: "16'-17'",
    overallLength: "20'3\"",
    bowEyeMin: "13'",
    bowEyeMax: "18'",
    gvwr: 2485,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "ST175/80R 13 LRC 5H",
    overallWidth: "93\"",
    betweenFenders: "76\"",
    sourceSheet: "Galvanized Bunk"
  },
  {
    model: "VB-2425",
    capacity: 2425,
    boatLength: "16'-18'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 2985,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST185/80R 13 LRD 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Galvanized Bunk"
  },
  {
    model: "VB-2625",
    capacity: 2625,
    boatLength: "17'-19'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 3185,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Galvanized Bunk"
  },
  {
    model: "VB-2825",
    capacity: 2825,
    boatLength: "18'-20'",
    overallLength: "22'1\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 3525,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Galvanized Bunk"
  },
  // Galvanized Bunk Tandem Axle
  {
    model: "VBT-3625",
    capacity: 3625,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 4585,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Galvanized Bunk"
  },
  {
    model: "VBT-5225",
    capacity: 5225,
    boatLength: "21'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 6165,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Galvanized Bunk"
  },
  // Galvanized Roller Single Axle
  {
    model: "VR-2425",
    capacity: 2425,
    boatLength: "16'-18'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 2985,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST185/80R 13 LRD 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Galvanized Roller",
    rollers: 6
  },
  {
    model: "VR-2625",
    capacity: 2625,
    boatLength: "17'-19'",
    overallLength: "19'10\"",
    bowEyeMin: "14'",
    bowEyeMax: "18'",
    gvwr: 3185,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Galvanized Roller",
    rollers: 6
  },
  // Galvanized Roller Tandem Axle
  {
    model: "VRT-3625",
    capacity: 3625,
    boatLength: "18'-20'",
    overallLength: "22'10\"",
    bowEyeMin: "16'",
    bowEyeMax: "20'",
    gvwr: 4585,
    tongueJack: "Single Wheel",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Galvanized Roller",
    rollers: 8
  },
  // PWC Trailers (VW- prefix)
  {
    model: "VW-1325",
    capacity: 1325,
    boatLength: "10'-12'",
    overallLength: "15'2\"",
    bowEyeMin: "7'",
    bowEyeMax: "10'6\"",
    gvwr: 1535,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "4.80 X 12 LRC 5H",
    overallWidth: "60\"",
    betweenFenders: "42\"",
    sourceSheet: "PWC"
  },
  {
    model: "VW-2025",
    capacity: 2025,
    boatLength: "12'-14'",
    overallLength: "17'6\"",
    bowEyeMin: "9'",
    bowEyeMax: "13'",
    gvwr: 2485,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "ST175/80R 13 LRC 5H",
    overallWidth: "93\"",
    betweenFenders: "76\"",
    sourceSheet: "PWC"
  },
  // Aluminum PWC Trailers (VAW- prefix)
  {
    model: "VAW-1325",
    capacity: 1325,
    boatLength: "10'-12'",
    overallLength: "15'2\"",
    bowEyeMin: "7'",
    bowEyeMax: "10'6\"",
    gvwr: 1535,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "4.80 X 12 LRC 5H",
    overallWidth: "60\"",
    betweenFenders: "42\"",
    sourceSheet: "Aluminum PWC"
  },
  {
    model: "VAW-2025",
    capacity: 2025,
    boatLength: "12'-14'",
    overallLength: "17'6\"",
    bowEyeMin: "9'",
    bowEyeMax: "13'",
    gvwr: 2485,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "ST175/80R 13 LRC 5H",
    overallWidth: "93\"",
    betweenFenders: "76\"",
    sourceSheet: "Aluminum PWC"
  },
  // Pontoon Trailers (VP- prefix)
  {
    model: "VP-3325",
    capacity: 3325,
    boatLength: "20'-22'",
    overallLength: "24'",
    bowEyeMin: "17'6\"",
    bowEyeMax: "21'",
    gvwr: 4100,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Pontoon",
    minBunkWidth: "22\"",
    maxBunkWidth: "30\""
  },
  {
    model: "VP-4325",
    capacity: 4325,
    boatLength: "22'-24'",
    overallLength: "26'6\"",
    bowEyeMin: "18'",
    bowEyeMax: "23'",
    gvwr: 5125,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Pontoon",
    minBunkWidth: "22\"",
    maxBunkWidth: "30\""
  },
  // Pontoon Tandem Axle (VPT- prefix)
  {
    model: "VPT-5325",
    capacity: 5325,
    boatLength: "24'-26'",
    overallLength: "28'6\"",
    bowEyeMin: "20'",
    bowEyeMax: "25'",
    gvwr: 6325,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Pontoon",
    minBunkWidth: "22\"",
    maxBunkWidth: "30\""
  },
  {
    model: "VPT-7325",
    capacity: 7325,
    boatLength: "26'-28'",
    overallLength: "30'6\"",
    bowEyeMin: "22'",
    bowEyeMax: "27'",
    gvwr: 8525,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Pontoon",
    minBunkWidth: "22\"",
    maxBunkWidth: "30\""
  },
  // Commander Trailers (COM- prefix)
  {
    model: "COM-5025",
    capacity: 5025,
    boatLength: "22'-24'",
    overallLength: "26'",
    bowEyeMin: "18'",
    bowEyeMax: "23'",
    gvwr: 6025,
    tongueJack: "Single Wheel",
    axles: 1,
    brakes: "Disc",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Commander"
  },
  {
    model: "COM-6025",
    capacity: 6025,
    boatLength: "24'-26'",
    overallLength: "28'",
    bowEyeMin: "20'",
    bowEyeMax: "25'",
    gvwr: 7225,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-1",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Commander"
  },
  {
    model: "COM-8025",
    capacity: 8025,
    boatLength: "26'-28'",
    overallLength: "30'",
    bowEyeMin: "22'",
    bowEyeMax: "27'",
    gvwr: 9625,
    tongueJack: "Flat Foot",
    axles: 2,
    brakes: "Disc-2",
    tireSize: "ST225/75R 15 LRD 6H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Commander"
  },
  // Skiff Trailers (VASK- prefix)
  {
    model: "VASK-1825",
    capacity: 1825,
    boatLength: "14'-16'",
    overallLength: "19'",
    bowEyeMin: "11'",
    bowEyeMax: "15'",
    gvwr: 2225,
    tongueJack: "Optional",
    axles: 1,
    brakes: "None",
    tireSize: "ST175/80R 13 LRC 5H",
    overallWidth: "93\"",
    betweenFenders: "76\"",
    sourceSheet: "Skiff"
  },
  {
    model: "VASK-2425",
    capacity: 2425,
    boatLength: "16'-18'",
    overallLength: "21'",
    bowEyeMin: "13'",
    bowEyeMax: "17'",
    gvwr: 2985,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST185/80R 13 LRD 5H",
    overallWidth: "89\"",
    betweenFenders: "71\"",
    sourceSheet: "Skiff"
  },
  {
    model: "VASK-2825",
    capacity: 2825,
    boatLength: "18'-20'",
    overallLength: "23'",
    bowEyeMin: "15'",
    bowEyeMax: "19'",
    gvwr: 3525,
    tongueJack: "Optional",
    axles: 1,
    brakes: "Optional",
    tireSize: "ST205/75R 14 LRC 5H",
    overallWidth: "100\"",
    betweenFenders: "81\"",
    sourceSheet: "Skiff"
  }
];

// Helper functions to filter models by type
export const getAluminumBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VAB-') || model.model.startsWith('VATB-')
  );
};

export const getAluminumRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VAR-') || model.model.startsWith('VATR-')
  );
};

export const getAluminumSingleAxleBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VAB-') && model.axles === 1
  );
};

export const getAluminumTandemAxleBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VATB-') && model.axles === 2
  );
};

export const getAluminumTripleAxleBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VATB-') && model.axles === 3
  );
};

export const getAluminumSingleAxleRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VAR-') && model.axles === 1
  );
};

export const getAluminumTandemAxleRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VATR-') && model.axles === 2
  );
};

export const getGalvanizedBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VB-') || model.model.startsWith('VBT-')
  );
};

export const getGalvanizedRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VR-') || model.model.startsWith('VRT-')
  );
};

export const getGalvanizedSingleAxleBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VB-') && model.axles === 1
  );
};

export const getGalvanizedTandemAxleBunkModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VBT-') && model.axles === 2
  );
};

export const getGalvanizedSingleAxleRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VR-') && model.axles === 1
  );
};

export const getGalvanizedTandemAxleRollerModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VRT-') && model.axles === 2
  );
};

export const getPWCModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VW-') || model.model.startsWith('VAW-')
  );
};

export const getGalvanizedPWCModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VW-')
  );
};

export const getAluminumPWCModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VAW-')
  );
};

export const getPontoonModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VP-') || model.model.startsWith('VPT-')
  );
};

export const getPontoonSingleAxleModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VP-') && model.axles === 1
  );
};

export const getPontoonTandemAxleModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VPT-') && model.axles === 2
  );
};

export const getCommanderModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('COM-')
  );
};

export const getSkiffModels = (): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.model.startsWith('VASK-')
  );
};

export const getAllTrailerModels = (): TrailerModel[] => {
  return TRAILER_MODELS;
};

export const getTrailersByCapacityRange = (minCapacity: number, maxCapacity: number): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.capacity >= minCapacity && model.capacity <= maxCapacity
  );
};

export const getTrailersByBoatLength = (boatLength: string): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.boatLength.includes(boatLength) ||
    model.boatLength.includes(boatLength.replace("'", "'"))
  );
};

export const getTrailersBySourceSheet = (sourceSheet: string): TrailerModel[] => {
  return TRAILER_MODELS.filter(model =>
    model.sourceSheet.toLowerCase().includes(sourceSheet.toLowerCase())
  );
};

export const searchTrailerModels = (query: string): TrailerModel[] => {
  const lowerQuery = query.toLowerCase();
  return TRAILER_MODELS.filter(model =>
    model.model.toLowerCase().includes(lowerQuery) ||
    model.sourceSheet.toLowerCase().includes(lowerQuery) ||
    model.boatLength.toLowerCase().includes(lowerQuery) ||
    model.tireSize.toLowerCase().includes(lowerQuery) ||
    model.brakes.toLowerCase().includes(lowerQuery)
  );
};

export const getModelByName = (modelName: string): TrailerModel | undefined => {
  return TRAILER_MODELS.find(model => model.model === modelName);
};